import { render } from "./StaticIntro.vue?vue&type=template&id=4100f524&scoped=true&lang=html"
import script from "./StaticIntro.vue?vue&type=script&lang=js"
export * from "./StaticIntro.vue?vue&type=script&lang=js"

import "./StaticIntro.vue?vue&type=style&index=0&id=4100f524&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4100f524"]])

export default __exports__